import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "width": "14", "height": "13", "viewBox": "0 0 14 13", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("g", { attrs: { "id": "Group 1792" } }, [_c("g", { attrs: { "id": "Group 7870" } }, [_c("path", { attrs: { "id": "Vector 88", "d": "M5.35 1H2C1.72386 1 1.5 1.22386 1.5 1.5V11.5C1.5 11.7761 1.72386 12 2 12H12C12.2761 12 12.5 11.7761 12.5 11.5V8.15", "stroke": "currentColor", "stroke-width": "1.5" } }), _c("path", { attrs: { "id": "Vector 87", "d": "M7.5 1H12.5M12.5 1V6M12.5 1L7.5 6", "stroke": "currentColor", "stroke-width": "1.5" } })])])]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const LinkIcon = __component__.exports;
export {
  LinkIcon as default
};
